import React from 'react';
import { NameDateOption } from './Options.styles';

export const optionDateLabel = (
  dateLabel: string,
  name: string | null | undefined,
  isMobile: boolean
) => {
  const shownName = typeof name === 'string' && name.trim() ? name : undefined;
  if (isMobile) {
    return shownName ? `${dateLabel}: ${shownName}` : dateLabel;
  }
  return (
    <NameDateOption>
      {shownName && <strong>{shownName}</strong>}
      {dateLabel}
    </NameDateOption>
  );
};
